module.exports = __webpack_public_path__ + "assets/2e2aefb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/play-button-orange.png
// module id = 101
// module chunks = 0